import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SCRAPE_DATA } from '../data/scrapeData';
import { GLOBAL_COMPANY_INFO, getResizedImageUrl } from '../lib/cms';
import GalleryLightbox from '../components/GalleryLightbox';

export default function IndendorsPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240111-123722-scaled.jpg',
      alt: 'Sort-hvid kofigur i garage',
      title: 'Kofigur i garage (Før)',
      tag: 'Før'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240112-161618-scaled.jpg',
      alt: 'Sort-hvid kostatue i værksted på palle',
      title: 'Kostatue i værksted (Efter)',
      tag: 'Efter'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240109-130816-scaled.jpg',
      alt: 'Hems med sort gelænder og plastdækket gulv',
      title: 'Hems med sort gelænder'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240108-140123-scaled.jpg',
      alt: 'Gelænder ved trappe dækket gulv under renovering',
      title: 'Trappegelænder under renovering'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240109-130829-scaled.jpg',
      alt: 'Mørkt trægelænder under renovering indendørs',
      title: 'Mørkt trægelænder'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240108-140106-scaled.jpg',
      alt: 'Trappe med gelænder og afdækket gulv',
      title: 'Trappe med afdækket gulv'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-081024-scaled.jpg',
      alt: 'Indendørs trappe med grøn gelænder og hvide vægge',
      title: 'Nymalet trappe med grønt gelænder'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240718-080953-scaled.jpg',
      alt: 'Smal trappe med grøn gelænder og røde vægge',
      title: 'Smal trappe med røde accentvægge'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt007.jpg',
      alt: 'Hvide dobbeltdøre med glasruder indendørs',
      title: 'Hvide dobbeltdøre med glasruder'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt006.jpg',
      alt: 'Hvid klassisk indendørs dør med paneler',
      title: 'Klassisk dør med paneler'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/projekt005.jpg',
      alt: 'Hvide garderobeskabe med dekorative paneler',
      title: 'Garderobeskabe med paneler'
    },
    {
      src: 'https://assets.auxodev.dk/assets/f8dcc12c-2687-46b4-9001-d689bb79e5d8/img-20240327-161629-scaled.jpg',
      alt: 'Moderne køkken med geometrisk tapet og køkkenø',
      title: 'Køkken med geometrisk mønstertapet'
    }
  ];

  return (
    <div className="bg-[#F8FAFC] pt-28 pb-20">
      
      {/* Banner */}
      <section className="bg-[#1D352E] text-white py-16 mb-16 -mt-[10px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-white text-sm font-semibold tracking-wider uppercase">
              Ydelser / Indendørs
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight">
              {SCRAPE_DATA.indendors.mainHeading}
            </h1>
            <p className="text-gray-200 text-lg">
              {SCRAPE_DATA.indendors.subHeading}
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
        
        {/* Before / After Highlight */}
        <div className="bg-white rounded-3xl p-8 sm:p-10 border border-slate-200 shadow-sm space-y-8">
          <div className="text-center max-w-2xl mx-auto space-y-2">
            <span className="text-[#65237e] text-xs font-semibold uppercase tracking-wider">
              Eksempel på forvandling
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1D352E]">
              Før & Efter
            </h2>
            <p className="text-gray-600 text-sm">
              Se et af vores specielle indendørs renoveringsprojekter før og efter behandling.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Before */}
            <div
              onClick={() => setLightboxIndex(0)}
              className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group cursor-pointer"
            >
              <img
                src={getResizedImageUrl(images[0].src, 800, 85)}
                alt={images[0].alt}
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-4 left-4 bg-black/70 text-white font-bold text-xs uppercase px-3 py-1.5 rounded-md">
                Før
              </div>
            </div>

            {/* After */}
            <div
              onClick={() => setLightboxIndex(1)}
              className="relative rounded-2xl overflow-hidden shadow-md border border-gray-200 group cursor-pointer"
            >
              <img
                src={getResizedImageUrl(images[1].src, 800, 85)}
                alt={images[1].alt}
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-4 left-4 bg-[#1D352E] text-white font-bold text-xs uppercase px-3 py-1.5 rounded-md">
                Efter
              </div>
            </div>
          </div>
        </div>

        {/* Verbatim Scraped Content */}
        <div className="bg-white rounded-3xl p-8 sm:p-12 border border-[#EFECE6] shadow-sm space-y-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#1D352E]">
            {SCRAPE_DATA.indendors.subHeading}
          </h2>
          <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
            {SCRAPE_DATA.indendors.body}
          </p>

          <div className="pt-4 flex flex-wrap items-center gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-semibold text-white bg-[#65237e] hover:bg-[#521b67] rounded-xl transition-colors shadow-md"
            >
              <span>Kontakt Carsten i dag</span>
              <i className="fa-solid fa-arrow-right text-xs" />
            </Link>
            <a
              href={`tel:${GLOBAL_COMPANY_INFO.phone_raw}`}
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-semibold text-[#1D352E] bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors nowrap-contact"
            >
              <i className="fa-solid fa-phone text-[#65237e]" />
              <span className="nowrap-contact">Ring på {GLOBAL_COMPANY_INFO.phone}</span>
            </a>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-bold text-[#1D352E]">
              Billeder fra indendørs projekter
            </h3>
            <span className="text-xs text-gray-500 font-medium">
              Klik for stor visning
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {images.map((img, idx) => (
              <div
                key={idx}
                onClick={() => setLightboxIndex(idx)}
                className="group relative rounded-2xl overflow-hidden bg-white border border-[#EFECE6] shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-4/3 overflow-hidden bg-gray-100">
                  <img
                    src={getResizedImageUrl(img.src, 500, 80)}
                    alt={img.alt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>

      <GalleryLightbox
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
